import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Paragraph from "../../../elements/p/Paragraph";
import LazyLoadImg from "../../../elements/images/LazyLoadImg";
import ProductDropdownAdmin from "../../../../components/utils/dropdowns/ProductDropdownAdmin";
import ProductDropdownUser from "../../../../components/utils/dropdowns/ProductDropdownUser";
import { percentageReduction } from "../../../../functions/functions";
import currentAdminContext from "../../../../dataManager/context/currentAdminContext";
import { CgArrowsScrollH } from "react-icons/cg";
import LoaderCircle from "../../../utils/LoaderCircle";
import "../../../../css/App.css";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  //context variables
  const { currentAdmin } = useContext(currentAdminContext);

  //local state
  const [loading, setLoading] = useState(false);

  const dropdownToDisplay =
    currentAdmin && currentAdmin.role === 1 ? (
      <ProductDropdownAdmin productId={product.getId} />
    ) : (
      <ProductDropdownUser
        productId={product.getId}
        onChangeLoading={setLoading}
      />
    );

  return (
    <article
      onClick={() => navigate(`/produits/${product.getId}`)}
      className="relative mx-auto box-border  w-full cursor-pointer rounded-lg p-3 hover:shadow-2xl"
    >
      <div className="mx-auto flex w-full justify-center ">
        <LazyLoadImg
          img={product.getImage}
          alt={product.getName}
          classe="object-contain  w-full h-36 md:h-44 mt-8"
        />
      </div>

      <div className="mt-3">
        <Paragraph size="small" classe="text-secondary/90 line-clamp">
          {product.getCaracteristics}
        </Paragraph>
        <div className="mt-3 flex items-center space-x-1.5">
          <h3 className="font-nunito text-lg font-bold text-secondary md:text-xl">
            {product.getPrise + " fcfa"}
          </h3>
          <p className="text-xs text-secondary-light/50 line-through">
            {product.getOldPrise + " fcfa"}
          </p>
        </div>
      </div>
      <div className="absolute top-0 left-0 z-10 box-border flex w-full items-start justify-between px-1.5 py-2">
        <div
          className={`${
            currentAdmin ? "top-1" : "top-3"
          } w-18 tex-4xl relative -translate-y-2  px-2 py-1 font-bold`}
        >
          {dropdownToDisplay}
        </div>
        <p className="w-15 rounded-full border border-secondary px-1.5 py-1 font-nunito text-xs font-thin text-secondary">
          {percentageReduction(
            Number(product.getPrise),
            Number(product.getOldPrise)
          ) + " %"}
        </p>
      </div>
      {loading && (
        <dir className="absolute top-0 left-0  h-full w-full rounded bg-smoot opacity-70">
          <LoaderCircle
            size="large"
            contentColor="white"
            fillColor="primary"
            position="center"
          />
        </dir>
      )}
    </article>
  );
};

export default ProductCard;
